export const telecomFormParametersGeneration = ({
  type,
  contractId,
  contactId,
  addressId,
  contractData,
  characteristicsData,
  contactPreferences,
  action = 'save',
}) => {
  // eslint-disable-next-line compat/compat
  const options = new URLSearchParams()

  options.append('type', type || '')
  options.append('id', contractId || '')
  options.append('contact_id', contactId || '')
  options.append('address_id', addressId || '')
  options.append('action', action)
  options.append('prestation_type', characteristicsData.prestationType || '')
  options.append('product_type', characteristicsData.productType || '')

  options.append('offer_id', contractData.offerId ? parseInt(contractData.offerId) : '')
  options.append('organisation_id', contractData.providerId ? parseInt(contractData.providerId) : '')
  if (contractData.providerExternalId) {
    options.append('provider_external_id', contractData.providerExternalId)
  }
  options.append(
    'providers_options',
    contractData.providerOptions?.length > 0
      ? JSON.stringify(contractData.providerOptions?.map(option => option.id))
      : JSON.stringify([]),
  )

  if (contractData.businessCard !== undefined) {
    options.append('business_card', contractData.businessCard === 1 ? '1' : '0')
  }

  if (contactPreferences.createReviewsInteraction) {
    options.append('create_reviews_interaction', contactPreferences.createReviewsInteraction ? '1' : '0')
  }

  return options
}
